import { useLayoutEffect } from "react";
import { useWatch } from "react-hook-form";
import { GenericAsyncSelect, GenericAsyncSelectProps } from "components/Form/Select/GenericAsyncSelect";
import { useFloatingField } from "./context";
import { sizeStyles } from "./sizeStyles";

function FloatingSingleSelect<T>({
  control,
  name,
  onChangeCallback,
  chakraStyles,
  placeholder = "",
  ...rest
}: GenericAsyncSelectProps<T>) {
  const { setHasValue, size } = useFloatingField();
  const styles = sizeStyles[size];
  const value = useWatch({ control, name });

  useLayoutEffect(() => {
    setHasValue(!!value);
  }, [value, setHasValue]);

  return (
    <div className="floating-single-select">
      <GenericAsyncSelect<T>
        {...rest}
        control={control}
        name={name}
        placeholder={placeholder}
        onChangeCallback={(val) => {
          setHasValue(!!val);
          onChangeCallback?.(val);
        }}
        chakraStyles={{
          control: (provided: any) => ({
            ...provided,
            height: styles.inputHeight,
            minHeight: styles.inputHeight,
            maxHeight: styles.inputHeight,
            backgroundColor: "transparent",
          }),
          valueContainer: (provided: any) => ({
            ...provided,
            paddingLeft: 0,
            paddingInlineStart: 0,
          }),
          ...chakraStyles,
        }}
      />
    </div>
  );
}

export default FloatingSingleSelect;
